import { wpApi } from "./axios";

// ─── PRODUCTS ─────────────────────────────────────────────────────

export async function getProducts({
    page = 1,
    perPage = 12,
    category = "",
    search = "",
    orderby = "date",
    order = "desc",
    minPrice = "",
    maxPrice = "",
    featured = false,
    inStock = false,
} = {}) {
    const params = { page, per_page: perPage, orderby, order };
    if (category) params.category = category;
    if (search) params.search = search;
    if (minPrice) params.min_price = minPrice;
    if (maxPrice) params.max_price = maxPrice;
    if (featured) params.featured = "true";
    if (inStock) params.in_stock = "true";

    const response = await wpApi.get("/headless/v1/products", { params });
    return {
        products: response.data,
        totalPages: parseInt(response.headers["x-wp-totalpages"] || 1),
        total: parseInt(response.headers["x-wp-total"] || 0),
    };
}

export async function getProductBySlug(slug) {
    const response = await wpApi.get(`/headless/v1/products/${slug}`);
    return response.data;
}

export async function getProductById(id) {
    const response = await wpApi.get(`/headless/v1/products/${id}`);
    return response.data;
}

// ─── CATEGORIES ───────────────────────────────────────────────────

export async function getCategories({
    perPage = 100,
    parent = "",
    hideEmpty = true,
} = {}) {
    const params = { per_page: perPage, hide_empty: hideEmpty };
    if (parent !== "") params.parent = parent;
    const response = await wpApi.get("/headless/v1/categories", { params });
    return response.data;
}

export async function getCategoryBySlug(slug) {
    const response = await wpApi.get(`/headless/v1/categories/${slug}`);
    return response.data;
}

// ─── ORDERS ───────────────────────────────────────────────────────

export async function createOrder(orderData) {
    const response = await wpApi.post("/headless/v1/orders", orderData);
    return response.data;
}

export async function getMyOrders({ page = 1, perPage = 10 } = {}) {
    const response = await wpApi.get("/headless/v1/my-orders", {
        params: { page, per_page: perPage },
    });
    return response.data;
}

export async function getOrderById(orderId) {
    const response = await wpApi.get(`/headless/v1/my-orders/${orderId}`);
    return response.data;
}

// ─── CUSTOMER ─────────────────────────────────────────────────────

export async function getMyProfile() {
    const response = await wpApi.get("/headless/v1/profile");
    return response.data;
}

export async function updateMyProfile(data) {
    const response = await wpApi.put("/headless/v1/profile", data);
    return response.data;
}

// ─── COUPONS ──────────────────────────────────────────────────────

export async function validateCoupon(code) {
    const response = await wpApi.post("/headless/v1/validate-coupon", { code });
    return response.data;
}
